import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../store";
import { getBahnPlotRequest } from "../store/bahnPlotDuck";

const emptyBahnState = {
  config: undefined,
  data: undefined,
  status: undefined,
  error: undefined,
};

export const useBahnPlot = () => {
  const dispatch = useDispatch();

  const { config, data, status, error } = useSelector(
    (state: RootState) => state.bahnPlot || emptyBahnState
  );

  const loadBahnPlot = (id: number) => {
    dispatch(getBahnPlotRequest({ id }));
  };

  return {
    config,
    data,
    status,
    error,
    loadBahnPlot
  };
};
